/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import React from 'react';
import { shopNowBtn } from '../Styles/ButtonStyles';

// interface ButtonProps{
//     styles: string;
// }
const ButtonBlack = (): JSX.Element => {
    return (
        <div css={shopNowBtn}>
            <p style={{ color: 'black', fontFamily: 'AcuminRPro', margin: 0 }}>Shop Now</p>
            <img className='arrow' src='/assets/icons/ArrowRight.svg' alt='arrow-right' />
        </div>
    );
};

export default ButtonBlack;
